import { ApiService } from '@b2b/common/services/api/types';
import { clearFieldValues } from '@b2b/common/services/helpers';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';

export const ResourceFieldCreateDirectiveModule = angular
  .module('acme.common.directive.resourceFieldCreate', [
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.validate',
    'acme.common.service.permissions',
  ])
  .directive('resourceFieldCreate', [
    'ApiService',
    'ValidateService',
    'PermissionsService',
    'HelpersService',
    function ResourceFieldCreateDirective(
      ApiService: ApiService,
      ValidateService: TODO,
      PermissionsService: PermissionsService,
      HelpersService: TODO
    ) {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/resourceField/create/create.tpl.html',
        scope: {
          field: '=',
          entity: '=',
          fieldIndex: '@fieldindex',
          resourceTemplateId: '@resourcetemplateid',
          disableEdit: '@disableedit',
        },
        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function ResourceFieldCreateController(
            $scope: IScope & {
              resourceFieldCreate: TODO;
              field: TODO;
              fieldIndex: TODO;
              resourceTemplateId: TODO;
              entity: TODO;
            }
          ) {
            console.log($scope.fieldIndex);
            $scope.resourceFieldCreate = {
              fieldIndex: -1,
              fieldTypes: [
                { title: 'String', name: 'string' },
                { title: 'Number', name: 'number' },
              ],

              defaultValue: '',
              defaultType: 'string',

              isValueValid: true,
              invalidMessage: '',

              isNameValid: true,
              nameInvalidMessage: 'Name is required',

              isFieldValid: true,
              fieldInvalidMessage: '',

              parseValue: function () {
                var parsed;

                parsed = HelpersService.parseValueType(this.defaultType, this.defaultValue, true);
                $scope.field = clearFieldValues($scope.field);

                if (parsed) {
                  this.isValueValid = true;
                  if ($scope.field.hasOwnProperty(parsed.key)) {
                    $scope.field.type = parsed.type;
                    $scope.field[parsed.key] = parsed.value;
                    this.defaultType = parsed.simpleType;
                  }
                }

                return parsed;
              },

              save: function (index) {
                this.fieldIndex = index;
                this.isNameValid = ValidateService.validate([{ len: { value: $scope.field.name } }]);
                this.isValueValid = this.parseValue();

                console.log('save: ', $scope.field.name.length, this.isNameValid, this.isValueValid);

                if (this.isNameValid === false) {
                  // Don't continue there were issues
                  return;
                }

                if (this.isValueValid === false) {
                  this.invalidMessage = !this.isValueValid ? HelpersService.errors[0].message : '';
                  return;
                }

                console.log('resourceFieldCreate', $scope.field, $scope.resourceTemplateId);
                $scope.$emit('resourceFieldCreate::save', { field: $scope.field, index: this.fieldIndex });

                if ($scope.resourceTemplateId && $scope.resourceTemplateId != -1) {
                  console.log('resourceFieldCreate', $scope.resourceTemplateId);
                  if (
                    $scope.entity &&
                    PermissionsService.check('ENTITY_TEMPLATE_' + $scope.entity.singular.toUpperCase() + '_UPDATE')
                  ) {
                    ApiService.resource.field
                      .create($scope.field, $scope.resourceTemplateId)
                      .then(this.success, this.error);
                  } else {
                    $scope.$emit('Permissions::error');
                  }
                }
              },

              cancel: function (index) {
                this.fieldIndex = index;
                $scope.$emit('resourceFieldCreate::cancel', { index: this.fieldIndex });
              },

              success: function (response, status, headers, config) {
                $scope.$emit('resourceFieldCreate::save::success', {
                  response: response,
                  status: status,
                  headers: headers,
                  config: config,
                  field: $scope.field,
                  index: $scope.resourceFieldCreate.fieldIndex,
                });
              },

              error: function (response, status, headers, config) {
                $scope.resourceFieldCreate.isFieldValid = false;
                $scope.resourceFieldCreate.fieldInvalidMessage = response.data.error;
                $scope.$emit('resourceFieldCreate::save::error', {
                  response: response,
                  status: status,
                  headers: headers,
                  config: config,
                  field: $scope.field,
                  index: $scope.resourceFieldCreate.fieldIndex,
                });
              },
            };
          },
        ],
      };
    },
  ]).name;
